import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import React from 'react';
import { useIsSSR } from 'react-aria';
import { SelectBase } from '../SelectBase/SelectBase.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { SelectGroup } from './SelectGroup.es.js';
import { SelectItem } from './SelectItem.es.js';
import { VisuallyHidden, Icon } from '@zapier/design-system';

const Select = (_a) => {
  var { children, errorMessage, helpText, isInvalid = false, isLabelHidden = false, label } = _a, props = __rest(_a, ["children", "errorMessage", "helpText", "isInvalid", "isLabelHidden", "label"]);
  const isSSR = useIsSSR();
  if (isSSR) {
    return null;
  }
  return React.createElement(
    SelectBase,
    Object.assign({}, props, { isInvalid }),
    isLabelHidden ? React.createElement(
      VisuallyHidden,
      null,
      React.createElement(SelectBase.Label, null, label)
    ) : React.createElement(SelectBase.Label, null, label),
    React.createElement(
      SelectBase.TriggerButton,
      null,
      React.createElement(SelectBase.Value, null),
      React.createElement(Icon, { name: "arrowDropdown", color: "TextWeaker", size: props.size === "compact" ? 20 : 24 })
    ),
    isInvalid && errorMessage ? React.createElement(ErrorMessage, { isCompact: props.size === "compact" }, errorMessage) : helpText && React.createElement(SelectBase.Description, null, helpText),
    React.createElement(
      SelectBase.Popover,
      null,
      React.createElement(SelectBase.ListBox, null, children)
    )
  );
};
Select.Item = SelectItem;
Select.Group = SelectGroup;

export { Select };
//# sourceMappingURL=Select.es.js.map
